export default {
  label: 'Publication Type',
  placeholder: 'All',
  items: {
    all: 'All',
    organic: 'Organic',
    boosted: 'Boosted',
  },
};
